
import { defineComponent, reactive, toRefs } from 'vue';

export default defineComponent({
    /*フッター*/
    name: 'SiteFooter',
    setup() {
        const state = reactive({
            pages: [
                {
                    title: '個人情報保護方針',
                    link: 'https://usen.com/legal/privacy1.html',
                },
                {
                    title: '個人情報の取り扱いについて',
                    link: 'https://usen.com/legal/privacy2.html',
                },
                {
                    title: '特定個人情報の取り扱いについて',
                    link: 'https://usen.com/legal/privacy3.html',
                },
                {
                    title: '勧誘方針',
                    link: 'https://usen.com/legal/solicitation.html',
                },
                {
                    title: '情報セキュリティ基本方針',
                    link: 'https://usen.com/infosec/',
                },
                {
                    title: 'サイトポリシー',
                    link: 'https://usen.com/legal/policy.html',
                },
                {
                    title: 'サイトマップ',
                    link: 'https://usen.com/sitemap/',
                },
                {
                    title: '放送番組審議会',
                    link: 'https://usen.com/company/council.html',
                },
                {
                    title: 'SDGsの取組みについて',
                    link: 'https://usen.com/csr/SDGs/',
                },
                {
                    title: '会員規約',
                    link: `${process.env.VUE_APP_API_URL_ASSETS}/pdf/um_agreement.pdf`,
                },
            ],
        });
        return {
            ...toRefs(state),
        };
    },
});
